import axios from '@/axios'

const API_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/alquileres`
const ENDPOINTS = {
  myOwnerPortal: `${API_BASE}/mi-cartera-propietario/`,
}

const state = {
  loading: false,
  error: null,
  vinculacion: null,
  propietario: null,
  inmobiliaria: null,
  propiedades: [],
  contratos: [],
  recibos: [],
  liquidaciones: [],
  documentos: [],
  resumen: null,
}

const mutations = {
  SET_LOADING(state, val) { state.loading = val },
  SET_ERROR(state, err) { state.error = err },
  SET_VINCULACION(state, payload) { state.vinculacion = payload },
  SET_PROPIETARIO(state, payload) { state.propietario = payload },
  SET_INMOBILIARIA(state, payload) { state.inmobiliaria = payload },
  SET_PROPIEDADES(state, payload) { state.propiedades = payload || [] },
  SET_CONTRATOS(state, payload) { state.contratos = payload || [] },
  SET_RECIBOS(state, payload) { state.recibos = payload || [] },
  SET_LIQUIDACIONES(state, payload) { state.liquidaciones = payload || [] },
  SET_DOCUMENTOS(state, payload) { state.documentos = payload || [] },
  SET_RESUMEN(state, payload) { state.resumen = payload },
  RESET_PORTAL_DATA(state) {
    state.propietario = null
    state.inmobiliaria = null
    state.propiedades = []
    state.contratos = []
    state.recibos = []
    state.liquidaciones = []
    state.documentos = []
    state.resumen = null
  },
}

const actions = {
  async fetchMyOwnerPortal({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const { data } = await axios.get(ENDPOINTS.myOwnerPortal, { withCredentials: true })

      commit('SET_VINCULACION', data.vinculacion || null)

      if (data.propietario) {
        commit('SET_PROPIETARIO', data.propietario)
        commit('SET_INMOBILIARIA', data.inmobiliaria || null)
        commit('SET_PROPIEDADES', data.propiedades)
        commit('SET_CONTRATOS', data.contratos)
        commit('SET_RECIBOS', data.recibos)
        commit('SET_LIQUIDACIONES', data.liquidaciones)
        commit('SET_DOCUMENTOS', data.documentos)
        commit('SET_RESUMEN', data.resumen)
      } else {
        commit('RESET_PORTAL_DATA')
      }
    } catch (err) {
      if (err?.response?.status === 404) {
        commit('SET_VINCULACION', null)
        commit('RESET_PORTAL_DATA')
        commit('SET_ERROR', null)
      } else {
        commit('SET_ERROR', err.response?.data || err.message || 'Error cargando datos del portal de propietarios')
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },
}

const getters = {
  ownerVinculacion: s => s.vinculacion,
  ownerVinculacionStatus: s => s.vinculacion?.status || null,
  ownerPropietario: s => s.propietario,
  ownerInmobiliaria: s => s.inmobiliaria,
  ownerPropiedades: s => s.propiedades,
  ownerContratos: s => s.contratos,
  ownerRecibos: s => s.recibos,
  ownerLiquidaciones: s => s.liquidaciones,
  ownerDocumentos: s => s.documentos,
  ownerResumen: s => s.resumen,
  ownerPortalLoading: s => s.loading,
  ownerPortalError: s => s.error,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
